import { EditorCardProvider } from '@atlaskit/editor-card-provider';
import type { CardAppearance, EnvironmentsKeys } from '@atlaskit/linking-common';
import type { CardClient } from '@atlaskit/link-provider';

/**
 * Confluence-specific EditorCardProvider that extends the platform EditorCardProvider.
 * This class can be extended further by Confluence to customize smart link behavior.
 */
export class ConfluenceEditorCardProvider extends EditorCardProvider {
	constructor(
		envKey?: EnvironmentsKeys,
		baseUrlOverride?: string,
		onResolve?: (url: string) => void,
		customCardClient?: CardClient,
	) {
		super(envKey, baseUrlOverride, 'CONFLUENCE', onResolve, customCardClient);
	}

	// TODO: Override for Confluence-specific defaults (still call super for base class fallback)
	// 	https://hello.jira.atlassian.cloud/browse/CCINT-7186
	protected getHardCodedAppearance(url: string): CardAppearance | undefined {
		return super.getHardCodedAppearance(url);
	}
}
